<div [formGroup]="parentForm()">
  <div class="mb-(--space-4) max-w-80">
    <ces-text-field
      formControlName="name"
      class="w-full"
      [placeholder]="'common.placeholders.measureName' | transloco"
      id="name"
      [label]="'common.labels.name' | transloco"
      [required]="true"
      [minLength]="3"
      [maxLength]="50"
      [unicityArray]="existingNames()"
      unicityKey="name" />
  </div>

  <div class="mb-(--space-4) max-w-80">
    <ces-select-field
      [filter]="true"
      [required]="true"
      class="w-full"
      formControlName="measureTypeId"
      [label]="'common.labels.type' | transloco"
      optionsStore="MeasureType"
      [placeholder]="'common.placeholders.selectMeasureType' | transloco" />
  </div>

  <div class="mb-(--space-4) max-w-80">
    <ces-select-field
      [filter]="true"
      [required]="true"
      class="w-full"
      formControlName="unitId"
      [label]="'common.labels.unit' | transloco"
      [options]="unitOptions()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'common.placeholders.selectUnit' | transloco" />
  </div>

  <div class="mb-(--space-4) max-w-196">
    <ces-select-field
      [filter]="true"
      [multiSelect]="true"
      [optionsFilter]="{ property: 'assetId', value: assetId(), operator: 'equals' }"
      [storeLoadParams]="[assetId()]"
      [emptyFilterMessage]="'common.messages.noResults' | transloco"
      [emptyMessage]="'common.messages.noData' | transloco"
      formControlName="locationIds"
      [label]="'common.labels.locations' | transloco"
      optionsStore="Location"
      [placeholder]="'common.placeholders.selectLocations' | transloco"
      storeLoadMethod="getLocationsByAsset" />
  </div>

  <div class="flex items-center gap-(--space-2)">
    <p-checkbox inputId="priority" [binary]="true" formControlName="priority" />
    <label for="priority" class="cursor-pointer">{{ 'common.labels.mandatory' | transloco }}</label>
  </div>
</div>
